
export default {
  name: 'Menu',

  components: {
    MenuElement: () => import('./MenuElement'),
  },

  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
};
